import { render, staticRenderFns } from "./clipper-fixed.vue?vue&type=template&id=28b3bd6b&scoped=true"
import script from "./clipper-fixed.vue?vue&type=script&lang=js"
export * from "./clipper-fixed.vue?vue&type=script&lang=js"
import style0 from "./clipper-fixed.vue?vue&type=style&index=0&id=28b3bd6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b3bd6b",
  null
  
)

export default component.exports